export const moneyStringToNumber = (amount: string | number) => {
  if (typeof amount !== "string") {
    const conversion = Number(amount);
    return isNaN(conversion) ? 0 : conversion;
  }

  const trimmed = amount.trim();
  // Accounting notation wraps negatives in parentheses, e.g. ($1,234.56)
  const isParenNegative = /^\(.*\)$/.test(trimmed);
  const conversion = Number(trimmed.replace(/[$,()\s]/g, ""));

  if (isNaN(conversion)) return 0;
  return isParenNegative ? -conversion : conversion;
};

export const toCents = (amount: string | number) => {
  return Math.round(moneyStringToNumber(amount) * 100);
};
